var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef } from 'react';
import { useAccessibleMenu } from '../../core/hooks/useAccessibleMenu';
import { AccordionContext } from './AccordionContext';
import { useDefaultAccordionController } from './controllers/useDefaultAccordionController';
import { useSingleAlwaysOpenAccordionController } from './controllers/useSingleAlwaysOpenAccordionController';
import { useSinglePanelAccordionController } from './controllers/useSinglePanelAccordionController';
var accordionControllerMap = {
    singleExpanded: useSinglePanelAccordionController,
    alwaysOpenSingleItem: useSingleAlwaysOpenAccordionController,
    default: useDefaultAccordionController,
};
export var Accordion = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.theme, theme = _c === void 0 ? 'chevron' : _c, _d = _a.styleHeadingsAs, styleHeadingsAs = _d === void 0 ? 'paragraphHeading' : _d, _e = _a.type, type = _e === void 0 ? 'default' : _e, defaultExpanded = _a.defaultExpanded, onPanelChanged = _a.onPanelChanged, _f = _a.scrollToItemWhenOpened, scrollToItemWhenOpened = _f === void 0 ? true : _f, props = __rest(_a, ["theme", "styleHeadingsAs", "type", "defaultExpanded", "onPanelChanged", "scrollToItemWhenOpened"]);
    var containerRef = useRef(null);
    var menuHandles = useAccessibleMenu(containerRef, {
        focusFirstItemOnMount: false,
        menuItemSelector: '[aria-controls]',
    });
    // the useRef ensures the type can't be changed later
    var controllerRef = useRef((_b = accordionControllerMap[type]) !== null && _b !== void 0 ? _b : useDefaultAccordionController);
    var _g = controllerRef.current(ref, {
        onPanelChanged: onPanelChanged,
        defaultExpanded: defaultExpanded,
    }), getIsOpen = _g.getIsOpen, setIsOpen = _g.setIsOpen;
    return (React.createElement(AccordionContext.Provider
    // TODO: Defining this prop as a new object every render will cause the
    // context to change every render, with likely performance impacts on
    // children components. This should be memoized.
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    , { 
        // TODO: Defining this prop as a new object every render will cause the
        // context to change every render, with likely performance impacts on
        // children components. This should be memoized.
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: { theme: theme, styleHeadingsAs: styleHeadingsAs, getIsOpen: getIsOpen, setIsOpen: setIsOpen, type: type, scrollToItemWhenOpened: scrollToItemWhenOpened } },
        React.createElement("div", __assign({ ref: containerRef, role: "group" }, menuHandles, props))));
});
//# sourceMappingURL=Accordion.js.map